import { InjectionToken } from '@angular/core';

export const F3_APP_CONFIG = new InjectionToken<any>('F3_APP_CONFIG');
